import React from 'react';

import {assert} from 'Asserts';
import ModelTypeConstants from 'constants/ModelTypeConstants';
import SearchInput from 'search/inputs/SearchInput';

export interface EntryAndWorksheetSearchInputProps {
  autoFocus?: boolean;
  disableTyping?: boolean;
  enableSearchEntries?: boolean;
  enableSearchWorksheets?: boolean;
  isMulti?: boolean;
  onRemove: (itemId: string) => void;
  onSelect: (itemId: string) => void;
  selected: Array<string>;
  dropLeft?: boolean;
}

export default function EntryAndWorksheetSearchInput({
  autoFocus,
  disableTyping,
  enableSearchEntries = true,
  enableSearchWorksheets = true,
  isMulti,
  onRemove,
  onSelect,
  selected,
  dropLeft,
}: EntryAndWorksheetSearchInputProps): JSX.Element {
  assert(
    enableSearchEntries || enableSearchWorksheets,
    "At least one of 'enableSearchEntries' or 'enableSearchWorksheets' must be true"
  );
  return (
    <SearchInput
      autoFocus={autoFocus}
      disableTyping={disableTyping}
      isMulti={isMulti}
      placeholder={
        enableSearchEntries && enableSearchWorksheets
          ? 'Search for an entry or worksheet'
          : enableSearchEntries
            ? 'Search for an entry'
            : 'Search for a worksheet'
      }
      onRemove={onRemove}
      onSelect={onSelect}
      selected={selected}
      dropLeft={dropLeft}
      types={[
        ...(enableSearchEntries ? [ModelTypeConstants.ENTRY] : []),
        ...(enableSearchWorksheets ? [ModelTypeConstants.WORKSHEET] : []),
      ]}
    />
  );
}
